import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "drawer"]

  connect() {
    clearTimeout(this._closeTimer)
    document.body.style.overflow = "hidden"
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.overlayTarget.classList.add("my-tries-drawer-overlay--open")
        this.drawerTarget.classList.add("my-tries-drawer--open")
      })
    })
  }

  disconnect() {
    document.body.style.overflow = ""
  }

  close() {
    clearTimeout(this._closeTimer)
    this.overlayTarget.classList.remove("my-tries-drawer-overlay--open")
    this.drawerTarget.classList.remove("my-tries-drawer--open")
    this._closeTimer = setTimeout(() => {
      const container = document.getElementById("my_tries_feedback_drawer")
      if (container) container.innerHTML = ""
    }, 400)
  }

  closeOnOverlay(event) {
    if (event.target === event.currentTarget) this.close()
  }
}
